module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content modal-width"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 right"
  }, [_c('button', {
    staticClass: "order-form-button",
    on: {
      "click": function($event) {
        return _vm.Agree()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "order-form-button",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("No")])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0b62ec9a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b62ec9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PromptComponent.vue
// module id = 479
// module chunks = 4